import { createMuiTheme } from '@material-ui/core/';

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#eeeeee',
            light: '#ffffff',
            dark: '#bcbcbc',
            
        },
        secondary: {
            main: '#00000',
            light: '#9c4dcc',
            dark: '#38006b',
        }
    },
})

export default theme;